import React from 'react';
import { LocationPage } from './useLocationPage';
import './useLocationPage.css';

// ─── Images ───────────────────────────────────────────────────────────────────
// Swap out any of these for Sarasota-specific shots
import heroImg   from '../images/tampa3.webp';
import bgImg     from '../images/image8.webp';
import slideImg1 from '../images/image121.webp';
import slideImg2 from '../images/image117.webp';
import slideImg3 from '../images/image50.webp';

// ─── Config ───────────────────────────────────────────────────────────────────
const ballastPointConfig = {

  /* ── SEO ────────────────────────────────────────────────────────────────── */
  pageTitle:       'Ballast Point Tree Service | Sam\'s Tree Service',
  metaDescription: 'Professional tree trimming and removal in Ballast Point, FL. Sam\'s Tree Service handles dangerous trees safely and affordably.',
  canonicalUrl:    'https://samstreeservice.com/tree_service_ballast_point',

  /* ── Hero ───────────────────────────────────────────────────────────────── */
  heroHeading: 'Serving Ballast Point',
  heroImageUrl: heroImg,
  bgImageUrl:   bgImg,

  /* ── Slide images ───────────────────────────────────────────────────────── */
  slideImage1: slideImg1,
  slideImage2: slideImg2,
  slideImage3: slideImg3,

  /* ── Main text panel ────────────────────────────────────────────────────── */
  sectionHeading: 'Professional Tree Service in Ballast Point Specializing In Dangerous Trees',

  paragraphs: [
    `At <strong>Sam's Tree Service</strong>, we bring expert tree care to the 
     quiet, tree lined streets and waterfront properties of <strong>Ballast Point</strong>. 
     This established South Tampa neighborhood sits along Hillsborough Bay 
     where mature oaks shade stunning homes and bay breezes push constantly 
     against aging canopies. When those trees develop overhangs, storm damage, 
     or structural issues, our team handles them with the precision and respect 
     these properties deserve.`,

    `We specialize in <strong>precision tree removal and canopy management on 
     established waterfront residential properties</strong> large overhanging 
     limbs near homes and seawalls, storm weakened trunks, dense canopy growth 
     creating storm risk, and careful full removals that protect your 
     surrounding landscape throughout the process.`,

    `<strong>Sam's Tree Service</strong> provides trusted, affordable tree care 
     throughout <strong>Ballast Point</strong> and the surrounding 
     <strong>South Tampa Bay</strong> neighborhoods keeping your home 
     safe and your trees healthy all year long.`,
  ],
  ctaLabel: 'Request An Appointment',

  /* ── Service buttons (optional — defaults to the 4 standard ones) ────────── */
  // serviceButtons: [
  //   { label: 'Tree Trimming', to: '/tree_trimming' },
  //   { label: 'Tree Removal',  to: '/tree_removal'  },
  //   { label: 'Stump Removal', to: '/stump_removal'  },
  //   { label: 'Debris Hauling',to: '/debris_hauling' },
  // ],

  /* ── Google Map ─────────────────────────────────────────────────────────── */
  mapCity: 'Ballast Point, FL',
};

// ─── Page ─────────────────────────────────────────────────────────────────────
const Services_BallastPoint = () => <LocationPage config={ballastPointConfig} />;
export default Services_BallastPoint;
